import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";
import { PermissionsProvider } from "./context/PermissionsContext";
import ProtectedRoute from "./components/ProtectedRoute";
import DefaultRedirect from "./components/DefaultRedirect";
import Sidebar from "./components/Sidebar";
import Navbar from "./components/Navbar";
import Dashboard from "./pages/Dashboard";
import Clients from "./pages/Clients";
import IBClients from "./pages/IBClients";
import KycDocuments from "./pages/KycDocuments";
import ReferralTree from "./pages/ReferralTree";
import TradeReport from "./pages/TradeReport";
import "./App.css";
import AccountLedger from "./pages/AccountLedger";
import DailyInflow from "./pages/DailyInflow";
import InternalTransfer from "./pages/InternalTransfer";
import PaymentWallet from "./pages/PaymentWallet";
import CashCard from "./pages/CashCard";
import CoinPayment from "./pages/CoinPayment";
import PeachPayment from "./pages/PeachPayment";
import SupportDashboard from "./pages/SupportDashboard";
import ManageTicketStatus from "./pages/ManageTicketStatus";
import ManageTicketPriority from "./pages/ManageTicketPriority";
import CreateNewStaff from "./pages/CreateNewStaff";
import AllStaff from "./pages/AllStaff";
import CreateNewRole from "./pages/CreateNewRole";
import AllRole from "./pages/AllRole";
import CreateNewDepartment from "./pages/CreateNewDepartment";
import AllDepartment from "./pages/AllDepartment";
import AccountType from "./pages/AccountType";
import AccountStatus from "./pages/AccountStatus";
import TransactionStatus from "./pages/TransactionStatus";
import KycStatus from "./pages/KycStatus";
import IBStatus from "./pages/IBStatus";
import PromoSilder from "./pages/PromoSlider";
import BasicSettings from "./pages/BasicSettings";
import ThemeSettings from "./pages/ThemeSettings";
import BrandSetting from "./pages/BrandSetting";
import AutomateTransaction from "./pages/AutomateTransaction";
import BankAccountSettings from "./pages/BankAccountSettings";
import GoogleRecaptchaSettings from "./pages/GoogleRecaptchaSettings";
import IPManager from "./pages/IPManager";
import EmailDesign from "./pages/EmailDesign";
import BasicSettings1 from "./pages/BasicSettings1";
import LeverageList from "./pages/LeverageList";
import IBCommissionList from "./pages/IBCommissionList";
import IBCommissionRequests from "./pages/IBCommissionRequests";
import Reward from "./pages/Reward";
import Downloads from "./pages/Downloads";
import WebTrader from "./pages/WebTrader";
import AdminActivity from "./pages/AdminActivity";
import UserActivity from "./pages/UserActivity";
import AllLogActivity from "./pages/AllLogActivity";
import Profile from "./pages/Profile";
import ClientsEnhanced from "./pages/ClientsEnhanced";
import EditClient from "./pages/EditClient";
import AdminLogin from "./pages/AdminLogin";
import ApprovedAccounts from "./pages/ApprovedAccounts";
import RejectedMasterAccounts from "./pages/RejectedMasterAccounts";
import PendingAccounts from "./pages/PendingAccounts";
import CopyTradingAccounts from "./pages/CopyTradingAccounts";
import TradingAccounts from "./pages/TradingAccounts";
import ApprovedFollowers from "./pages/ApprovedFollowers";
import RejectedFollowers from "./pages/RejectedFollowers";
import DepositHistory from "./pages/DepositHistory";
import WithdrawalHistory from "./pages/WithdrawalHistory";
import PaymentMethods from "./pages/PaymentMethods";
import PaymentMethodHistory from "./pages/PaymentMethodHistory";
import PAMMClients from "./pages/PAMMClients";
import PAMMActiveAccounts from "./pages/PAMMActiveAccounts";
import PAMMReferralTree from "./pages/PAMMReferralTree";
import PAMMCommissionReport from "./pages/PAMMCommissionReport";
import PAMMCommissionSettings from "./pages/PAMMCommissionSettings";
import PAMMWithdrawalHistory from "./pages/PAMMWithdrawalHistory";
import ManageAccountTypes from "./pages/ManageAccountTypes";
import IBCommissionHistory from "./pages/IBCommissionHistory";
import IBCommissionWithdrawHistory from "./pages/IBCommissionWithdrawHistory";
import CreditInOut from "./pages/CreditInOut";
import RankManagement from "./pages/RankManagement";
import IBRewards from "./pages/IBRewards";
import RejectedDeposits from "./pages/RejectedDeposits";
import RejectedWithdrawals from "./pages/RejectedWithdrawals";

export default function App() {
  const [isAdminLoggedIn, setIsAdminLoggedIn] = useState(
    localStorage.getItem("isAdminLoggedIn") === "true"
  );

  // Callback to update login state after successful login
  const handleLoginSuccess = () => {
    setIsAdminLoggedIn(true);
  };

  if (!isAdminLoggedIn) {
    return (
      <PermissionsProvider>
        <Routes>
          <Route
            path="*"
            element={<AdminLogin onLoginSuccess={handleLoginSuccess} />}
          />
          <Route
            path="/admin-login"
            element={<AdminLogin onLoginSuccess={handleLoginSuccess} />}
          />
        </Routes>
      </PermissionsProvider>
    );
  }

  // If logged in, show the main app with sidebar
  return (
    <PermissionsProvider>
      <Sidebar>
        <div className="main-content">
          <div className="page-content">
            <Routes>
              <Route path="/" element={<DefaultRedirect />} />
              <Route
                path="/profile"
                element={
                  <ProtectedRoute requiredPermission="edit_profile">
                    <Profile />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute requiredPermission="view_dashboard">
                    <Dashboard />
                  </ProtectedRoute>
                }
              />

              {/* Clients */}
              <Route
                path="/clients"
                element={
                  <ProtectedRoute requiredModule="Clients">
                    <ClientsEnhanced />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/edit-client/:id"
                element={
                  <ProtectedRoute requiredPermission="edit_clients">
                    <EditClient />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/view-client/:id"
                element={
                  <ProtectedRoute requiredPermission="view_clients">
                    <EditClient />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/trading-accounts"
                element={
                  <ProtectedRoute requiredModule="Clients">
                    <TradingAccounts />
                  </ProtectedRoute>
                }
              />

              {/* IB Clients */}
              <Route
                path="/ib-clients"
                element={
                  <ProtectedRoute requiredModule="IB Clients">
                    <IBClients />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/copy-trading-accounts"
                element={
                  <ProtectedRoute requiredModule="IB Clients">
                    <CopyTradingAccounts />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/approved-followers"
                element={
                  <ProtectedRoute requiredModule="IB Clients">
                    <ApprovedFollowers />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/rejected-followers"
                element={
                  <ProtectedRoute requiredModule="IB Clients">
                    <RejectedFollowers />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ib-commission"
                element={
                  <ProtectedRoute requiredModule="IB Clients">
                    <ManageAccountTypes />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ib-commission-requests"
                element={
                  <ProtectedRoute requiredModule="IB Clients">
                    <IBCommissionRequests />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ib-commission-history"
                element={
                  <ProtectedRoute requiredModule="IB Clients">
                    <IBCommissionHistory />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ib-withdraw-history"
                element={
                  <ProtectedRoute requiredModule="IB Clients">
                    <IBCommissionWithdrawHistory />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/rank-management"
                element={
                  <ProtectedRoute requiredModule="IB Clients">
                    <RankManagement />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ib-rewards"
                element={
                  <ProtectedRoute requiredModule="IB Clients">
                    <IBRewards />
                  </ProtectedRoute>
                }
              />

              {/* Trade Report */}
              <Route path="/kyc-documents" element={<KycDocuments />} />
              <Route path="/referral-tree" element={<ReferralTree />} />
              <Route
                path="/trade-report"
                element={
                  <ProtectedRoute requiredPermission="view_trade_report">
                    <TradeReport />
                  </ProtectedRoute>
                }
              />
              <Route path="/account-ledger" element={<AccountLedger />} />
              <Route path="/daily-inflow" element={<DailyInflow />} />
              <Route path="/approved-accounts" element={<ApprovedAccounts />} />
              <Route path="/rejected-master-accounts" element={<RejectedMasterAccounts />} />
              <Route path="/pending-accounts" element={<PendingAccounts />} />
              <Route path="/internal-transfer" element={<InternalTransfer />} />
              <Route path="/deposit-history" element={<DepositHistory />} />
              <Route path="/withdraw-history" element={<WithdrawalHistory />} />
              <Route path="/rejected-deposits" element={<RejectedDeposits />} />
              <Route path="/rejected-withdrawals" element={<RejectedWithdrawals />} />
              <Route path="/credit-in-out" element={<CreditInOut />} />
              <Route path="/payment-ledger" element={<PaymentWallet />} />
              <Route path="/payment-methods" element={<PaymentMethods />} />
              <Route
                path="/payment-method-history"
                element={<PaymentMethodHistory />}
              />
              <Route path="/cash-card" element={<CashCard />} />
              <Route path="/coin-payment" element={<CoinPayment />} />
              <Route path="/peach-payment" element={<PeachPayment />} />
              <Route path="/support-dashboard" element={<SupportDashboard />} />
              <Route path="/manage-ticket" element={<ManageTicketStatus />} />
              <Route
                path="/manage-priority"
                element={<ManageTicketPriority />}
              />
              <Route path="/new-staff" element={<CreateNewStaff />} />
              <Route path="/all-staff" element={<AllStaff />} />
              <Route path="/new-role" element={<CreateNewRole />} />
              <Route path="/all-role" element={<AllRole />} />
              <Route path="/new-department" element={<CreateNewDepartment />} />
              <Route path="/all-department" element={<AllDepartment />} />
              <Route path="/account-type" element={<AccountType />} />
              <Route path="/account-status" element={<AccountStatus />} />
              <Route
                path="/transaction-status"
                element={<TransactionStatus />}
              />
              <Route path="/kyc-status" element={<KycStatus />} />
              <Route path="/ib-status" element={<IBStatus />} />

              {/* Settings */}
              <Route path="/promo-slider" element={<PromoSilder />} />
              <Route
                path="/basic-setting"
                element={
                  <ProtectedRoute requiredModule="App Settings">
                    <BasicSettings />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/theme-setting"
                element={
                  <ProtectedRoute requiredModule="App Settings">
                    <ThemeSettings />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/brand-setting"
                element={
                  <ProtectedRoute requiredModule="App Settings">
                    <BrandSetting />
                  </ProtectedRoute>
                }
              />
              <Route path="/auto" element={<AutomateTransaction />} />
              <Route path="/bank-account" element={<BankAccountSettings />} />
              <Route path="/recaptcha" element={<GoogleRecaptchaSettings />} />
              <Route path="/ip-manager" element={<IPManager />} />
              <Route
                path="/email-design"
                element={
                  <ProtectedRoute requiredModule="Mail Settings">
                    <EmailDesign />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/leverage"
                element={
                  <ProtectedRoute requiredModule="Platform Settings">
                    <LeverageList />
                  </ProtectedRoute>
                }
              />

              {/* Log Activity */}
              <Route path="/reward" element={<Reward />} />
              <Route path="/download" element={<Downloads />} />
              <Route path="/webtrader" element={<WebTrader />} />
              <Route path="/admin-acct" element={<AdminActivity />} />
              <Route path="/user-acct" element={<UserActivity />} />
              <Route
                path="/log-acct"
                element={
                  <ProtectedRoute requiredPermission="view_log_activity">
                    <AllLogActivity />
                  </ProtectedRoute>
                }
              />

              {/* PAMM */}
              <Route path="/pamm-clients" element={<PAMMClients />} />
              <Route
                path="/pamm-active-accounts"
                element={<PAMMActiveAccounts />}
              />
              <Route
                path="/pamm-referral-tree"
                element={<PAMMReferralTree />}
              />
              <Route
                path="/pamm-commission-report"
                element={<PAMMCommissionReport />}
              />
              <Route
                path="/pamm-commission-settings"
                element={<PAMMCommissionSettings />}
              />
              <Route
                path="/pamm-withdrawal-history"
                element={<PAMMWithdrawalHistory />}
              />
            </Routes>
          </div>
        </div>
      </Sidebar>
    </PermissionsProvider>
  );
}
